import {
  useAsync
} from "./chunk-FVZAR5OH.mjs";

// src/useTableData.ts
var createUseTableData = (httpClient) => (categoryName) => {
  return useAsync(
    async () => {
      if (categoryName) {
        const response = await httpClient.get(
          `/group/${categoryName}`
        );
        return response.data;
      }
      return null;
    },
    { deps: [categoryName] }
  );
};
export {
  createUseTableData
};
